<div
  class="rounded-[56px] p-[0.3rem]"
  style="background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)"
>
  <div class="rounded-[53px] bg-surface-0 dark:bg-surface-900 px-6 py-12 sm:px-16 sm:py-16">
    <app-loader [name]="loader()" [backgroundClass]="'rounded-xl'">
      <div class="text-center mb-8">
        <a [routerLink]="['/auth/login']">
          <img
            src="assets/layout/images/logo.svg"
            [alt]="'auth.register.logoAlt' | translate"
            class="mb-6 w-[64px] mx-auto"
          />
        </a>
        <h1 class="text-surface-900 dark:text-surface-0 text-3xl font-medium mt-0 mb-2">{{ title() }}</h1>
        @if (description()) {
          <p class="text-muted-color font-medium m-0">{{ description() }}</p>
        }
      </div>

      <ng-content />
    </app-loader>
  </div>
</div>
